/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const IPRangeMixinParser = /* #__PURE__ */ parsers.object([
    ['ipRange', codecString, 'ip_range'],
]);
export class IPRangeMixin extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return IPRangeMixinParser.decode(input).map(res => new IPRangeMixin(res));
    }
    static unsafeDecode(input) {
        return IPRangeMixin.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return IPRangeMixinParser.encode(data);
    }
    static schema() {
        return IPRangeMixinParser.schema();
    }
}
